exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-41bdc9ca]{padding-top:16px\n}\n.settings .el-checkbox[data-v-41bdc9ca]{display:block;margin:10px\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/modules/settings/index.vue"],"names":[],"mappings":";AACA,oBAAoB,gBAAgB;CACnC;AACD,wCAAwC,cAAc,WAAW;CAChE","file":"index.vue","sourcesContent":["\nh1[data-v-41bdc9ca]{padding-top:16px\n}\n.settings .el-checkbox[data-v-41bdc9ca]{display:block;margin:10px\n}"],"sourceRoot":""}]);

// exports
